import {
  getRegistrationMenuStatus,
  getRegistrationStatusTone,
  isBankAccountRegistered,
  isPersonalInformationRegistered,
} from "../../utils/user/profileRegistration";
import {
  getCountMenuStatus,
  getNotificationMenuStatus,
} from "../../utils/user/myPageMenuStatus";

const CLIENT_ALLOWED_IDS = [
  "notification",
  "followersAndFollowing",
  "emailPassword",
  "MCP",
  "personalInformation",
  "documentSeal",
  "other",
  "helpCenter",
  "signOut",
];

const leftColumnList = ({
  setSelectedItem,
  setShowRightColumn,
  handleSignout,
  handleHelpCenter,
  role,
  userData,
  myRolesCount,
  followersCount,
}) => {
  const isBankRegistered = isBankAccountRegistered(userData);
  const isPersonalInfoRegistered = isPersonalInformationRegistered(userData);

  // メニュー項目を選択 → 右カラム表示まで行う共通ハンドラ付きで生成する。
  const navItem = (id, name, extra = {}) => ({
    id,
    name,
    onClick: () => {
      setSelectedItem(id);
      setShowRightColumn(true);
    },
    ...extra,
  });

  const fullList = [
    { id: "wallet", name: "ウォレット", size: "section" },
    navItem("paymentDetails", "支払明細書"),
    navItem("bankAccount", "振込先銀行口座", {
      status: getRegistrationMenuStatus(isBankRegistered),
      statusTone: getRegistrationStatusTone(isBankRegistered),
    }),

    { id: "settings", name: "利用設定", size: "section" },
    navItem("notification", "通知", {
      status: getNotificationMenuStatus(userData?.notification_setting),
    }),
    navItem("role", "ロール", { status: getCountMenuStatus(myRolesCount) }),
    navItem("offerConditions", "オファーを引き受ける基準"),
    navItem("documentSeal", "御見積書の印影"),
    navItem("followersAndFollowing", "フォロワー・フォロー中", {
      status: getCountMenuStatus(followersCount),
    }),

    { id: "accountInfo", name: "アカウント情報", size: "section" },
    navItem("emailPassword", "メールアドレス・パスワード"),
    navItem("MCP", "MCP"),
    navItem("personalInformation", "個人情報", {
      status: getRegistrationMenuStatus(isPersonalInfoRegistered),
      statusTone: getRegistrationStatusTone(isPersonalInfoRegistered),
    }),

    { id: "other", name: "その他", size: "section" },
    {
      id: "helpCenter",
      name: "ヘルプセンター",
      size: "large",
      onClick: handleHelpCenter,
    },
    {
      id: "signOut",
      name: "サインアウト",
      size: "large",
      hasBorderBottom: true,
      onClick: handleSignout,
    },
  ];

  if (role === "CLIENT") {
    return fullList.filter((menuItem) => CLIENT_ALLOWED_IDS.includes(menuItem.id));
  }

  return fullList;
};

export default leftColumnList;
